<template>
  <section>
    <section v-if="professional === null">
      <div class="space-top-16 space-16" style="height: 100vh">
        <loader/>
      </div>
    </section>
    <section v-else id="card" ref="card">
      <div class="row professional-card-detail">
        <div class="col-4">
          <img src="/static/img/logo.png"
               alt=""
               class="professional-card-profile-badge">
          <img v-lazy="professional.picture"
               alt="cleaner picture"
               class="rounded-circle img-fluid professional-card-profile-image">
        </div>
        <div class="col-8">
          <div class="">
            <p>Cleaner ID : <span class="professional-card-id">{{ professional.id }}</span></p>
            <p>{{ professional.name }}</p>
          </div>
        </div>
      </div>
      <div class="row professional-card-contact">
        <div class="col-6">
          <p class="professional-card-contact-title">แม่บ้านบีนีท...มาให้บริการถึงที่</p>
          <p class="professional-card-contact-title" style="margin-bottom: 1em;">จองบริการ</p>
          <div class="professional-card-contact-detail">
            <img src="/static/img/ic_professional_card_tel.png">
            <p>02-113-1138</p>
          </div>
          <div class="professional-card-contact-detail">
            <img src="/static/img/ic_professional_card_www.png"
                 alt=""
                 class="">
            <p>www.BeNeat.co/Cleaner/{{ professional.id }}</p>
          </div>
        </div>
        <div class="col-6">
          <img src="/static/img/cleaner_card_qr_code.png"
               alt=""
               class="img-fluid">
        </div>
      </div>
      <div class="row professional-card-back">
        <div class="col-12">
          <img src="/static/img/professional_card_back.jpg"
               alt=""
               class="img-fluid">
        </div>
      </div>
    </section>
    <div class="row">
      <div class="col-12">
        <button class="button button-block button-large -cyan professional-card-download"
                @click="download">ดาวน์โหลด
        </button>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import html2canvas from 'html2canvas'
  import Loader from '../loader/Loader'

  export default {
    components: {
      Loader
    },
    data () {
      return {
        professionalId: this.$route.params.id,
        pageTitle: 'untitled'
      }
    },
    metaInfo () {
      return {
        title: this.pageTitle,
        titleTemplate: null
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        professional: 'professional/getProfessional'
      })
    },
    watch: {
      professional () {
        if (this.professional) {
          this.pageTitle = this.$options.filters.firstName(this.professional.name) + ' | '
          this.pageTitle += this.$i18n.t('message.professional.cleaning_expert_in')
          this.pageTitle += this.$options.filters.multiLangName(this.globalState.cities[this.professional.province_id])
          this.pageTitle += ' | BeNeat.co'
        }
      }
    },
    methods: {
      initialData () {
        if (this.professional) {
          this.shareUrl = 'https://beneat.co/cleaner/' + this.professionalId
          this.shareText = 'Highly recommend! ' + this.professional.name + ' @beneat'
        }

        const queryData = {
          professional_id: this.professionalId,
          language: this.$i18n.locale
        }
        this.$store.dispatch('professional/LOAD_PROFESSIONAL_DETAIL', queryData)
      },
      download () {
        html2canvas(this.$refs.card, {proxy: 'https://beneat.co/html2canvasproxy.php'}).then(canvas => {
          var lnk = document.createElement('a')
          /// the key here is to set the download attribute of the a tag
          lnk.download = 'card.png'

          /// convert canvas content to data-uri for link. When download
          /// attribute is set the content pointed to by link will be
          /// pushed as "download" in HTML5 capable browsers
          lnk.href = canvas.toDataURL('image/png;base64')

          /// create a "fake" click-event to trigger the download
          if (document.createEvent) {
            var e = document.createEvent('MouseEvents')
            e.initMouseEvent('click', true, true, window,
              0, 0, 0, 0, 0, false, false, false,
              false, 0, null)

            lnk.dispatchEvent(e)
          } else if (lnk.fireEvent) {
            lnk.fireEvent('onclick')
          }
        })
      }
    },
    mounted () {
      this.initialData()
    },
    created () {
      this.$store.commit('professional/SET_PROFESSIONAL_DETAIL', null)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/professional/CleanerCard.vue